import React from 'react'
import type { LedgerEntry } from './types'
import { formatDate, formatUSDC, shortId } from './format'

const th =
  'text-left text-xs font-semibold uppercase text-neutral-500 px-3 py-2'
const td = 'px-3 py-2 text-sm border-t border-neutral-100'

const statusCls: Record<LedgerEntry['status'], string> = {
  pending: 'bg-amber-100 text-amber-800',
  claimable: 'bg-green-100 text-green-800',
  void: 'bg-neutral-200 text-neutral-600',
}

type Props = { entries: LedgerEntry[] }

const LedgerTable: React.FC<Props> = ({ entries }) => {
  if (entries.length === 0) {
    return <div className="text-sm text-neutral-600">No ledger entries.</div>
  }
  return (
    <div className="overflow-x-auto border border-neutral-200 rounded-lg">
      <table className="min-w-full">
        <thead className="bg-neutral-50">
          <tr>
            <th className={th}>Date</th>
            <th className={th}>Type</th>
            <th className={th}>Amount</th>
            <th className={th}>Status</th>
            <th className={th}>Deal</th>
            <th className={th}>Referral</th>
            <th className={th}>Claimable at</th>
            <th className={th}>Reason</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((e) => (
            <tr key={e.id}>
              <td className={td}>{formatDate(e.created_at)}</td>
              <td className={td}>{e.type}</td>
              <td className={td}>{formatUSDC(e.amount_usdc)}</td>
              <td className={td}>
                <span
                  className={`px-2 py-0.5 rounded text-xs ${
                    statusCls[e.status]
                  }`}
                >
                  {e.status}
                </span>
              </td>
              <td className={td}>{e.deal_id ?? '—'}</td>
              <td className={td}>
                {e.referral_privy_id ? shortId(e.referral_privy_id) : '—'}
              </td>
              <td className={td}>{formatDate(e.claimable_at)}</td>
              <td className={td}>{e.reason ?? '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default LedgerTable
